import { useController } from "react-hook-form";
import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import { AutocompleteField, AutocompleteFieldProps } from "./AutocompleteField";

export interface FormSelectProps
    extends Pick<
        AutocompleteFieldProps,
        "helperText" | "isDisabled" | "label" | "name" | "options" | "placeholder"
    > {
    defaultValue?: string;
}

export function FormAutocomplete({
    defaultValue = "",
    helperText,
    isDisabled,
    label,
    name,
    options,
    placeholder,
}: FormSelectProps) {
    const { field, fieldState } = useController({
        name,
        defaultValue,
    });

    return (
        <FieldWrapper name={field.name}>
            <AutocompleteField
                helperText={helperText}
                inputRef={field.ref}
                isDisabled={isDisabled}
                isError={!!fieldState.error}
                label={label}
                name={field.name}
                onChange={(newValue) => field.onChange(newValue?.value)}
                options={options}
                placeholder={placeholder}
                value={options.find((option) => option.value === field.value) || null}
            />
        </FieldWrapper>
    );
}
